import { ReadonlyRadioGroup } from '@exam-center/components';
import {
  Flex,
  Grid,
  Box,
  FormLabel,
  Text,
  ReadonlyField,
  FormHelperText,
  AttachmentOutlinedIcon,
} from '@shared/components';

export interface AttachDocumentReadonlyFieldsProps {
  visibleFields: {
    attachDocument: boolean;
  };
  values: {
    enabled: boolean;
    fileName: string;
  };
}

export default function AttachDocumentReadonlyFields(
  props: Readonly<AttachDocumentReadonlyFieldsProps>,
) {
  const { visibleFields, values } = props;

  return (
    <Grid sx={{ gap: (theme) => theme.spacing(6), gridTemplate: '1fr / 240px 1fr' }}>
      <Box>
        <Text variant='body1Semibold'>มีเอกสารประกอบการสอบหรือไม่</Text>
      </Box>
      <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(4) }}>
        <ReadonlyRadioGroup
          options={[
            {
              label: 'ไม่มีเอกสาร',
              checked: !values.enabled,
            },
            {
              label: 'มีเอกสาร',
              checked: values.enabled,
            },
          ]}
        />
      </Flex>
      {visibleFields?.attachDocument ? (
        <>
          <FormLabel required sx={(theme) => ({ ...theme.typography.body1Semibold })}>
            อัปโหลดเอกสารแนบ
          </FormLabel>{' '}
          <Flex sx={(theme) => ({ gap: theme.spacing(1), flexDirection: 'column' })}>
            <ReadonlyField
              content={
                <Flex sx={(theme) => ({ gap: theme.spacing(2) })}>
                  <AttachmentOutlinedIcon />
                  <Text>{values.fileName}</Text>
                </Flex>
              }
            />
            <FormHelperText>สามารถอัปโหลดได้สูงสุด 1 ไฟล์ (ขนาดไม่เกิน 20 MB)</FormHelperText>
          </Flex>
        </>
      ) : null}
    </Grid>
  );
}
